import { App } from "./app";
import { Assignment } from "./assignment";
import { Content } from "@tt-app/api/content";
import { Exercise } from "./exercise";
import { LearningHistory } from "./learningHistory";
import { Pett } from "./pett";
import { TerratalkLive } from "@tt-app/api/terratalkLive";
import { User } from "@tt-app/api/user";
import { ReleaseNotes } from "@tt-app/api/releaseNotes";

const api = {
  app: new App(),
  assignment: new Assignment(),
  content: new Content(),
  exercise: new Exercise(),
  learningHistory: new LearningHistory(),
  pett: new Pett(),
  terratalkLive: new TerratalkLive(),
  user: new User(),
  releaseNotes: new ReleaseNotes()
};

export { api };
